import { render } from "./DashboardDataTableOld.vue?vue&type=template&id=ac9194a6"
import script from "./DashboardDataTableOld.vue?vue&type=script&lang=js"
export * from "./DashboardDataTableOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__